import { render, staticRenderFns } from "./AgreementCheckbox.vue?vue&type=template&id=cb29c6b8&"
import script from "./AgreementCheckbox.vue?vue&type=script&lang=ts&"
export * from "./AgreementCheckbox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports